import React from 'react';
import { useDropzone } from 'react-dropzone';
import PropTypes from 'prop-types';

function ReactDropzone({
  onDrop,
  accept,
  multiple,
  disabled,
  className,
  children,
  'data-testid': dataTestId,
}) {
  const {
    getRootProps,
    getInputProps,
    isDragActive,
    isDragReject,
    isDragAccept,
  } = useDropzone({
    onDrop,
    accept,
    multiple,
    disabled,
  });

  return React.createElement('div', {
    ...getRootProps({ className }),
    'data-testid': dataTestId,
    style: {
      opacity: disabled ? 0.5 : 1,
      cursor: disabled ? 'not-allowed' : 'pointer',
    },
  }, React.createElement('input', getInputProps()), typeof children === 'function'
    ? children({ isDragActive, isDragReject, isDragAccept })
    : children);
}

ReactDropzone.propTypes = {
  onDrop: PropTypes.func.isRequired,
  accept: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  multiple: PropTypes.bool,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
  'data-testid': PropTypes.string,
};

ReactDropzone.defaultProps = {
  accept: '',
  multiple: true,
  disabled: false,
  className: 'react-drop-zone',
  children: 'Drag and drop files here, or click to select files',
  'data-testid': undefined,
};

export default ReactDropzone;
